import AccordionDetails, {
  AccordionDetailsProps,
} from "@mui/material/AccordionDetails";

export type EmtAccordionDetailsProps = AccordionDetailsProps & {
  nonce?: string;
};

export function EmtAccordionDetails(props: EmtAccordionDetailsProps) {
  const { children, sx, ...rest } = props;
  return (
    <AccordionDetails
      {...rest}
      sx={{ padding: "20px 0", paddingTop: "10px", ...sx }}
    >
      {children}
    </AccordionDetails>
  );
}
